import * as React from 'react';
import {
  FieldStates,
  FormField,
  FormFieldMultiString,
  FormFieldProps
} from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { Register } from 'sos-common/js/commonTypes/Registers.types';
import { CheckBoxGroup } from 'sos-common/js/components/FormControls/CheckBoxGroup';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { StatisticsOrderRegisters } from '../../models';
import { getErrorMessageByFieldName } from '../../utilities/helpers';
import { translateFunc } from '../../utilities/translations';

export interface InternalRegistriesProps extends FormFieldProps<number[]> {
  registers: StatisticsOrderRegisters;
  Translate: translateFunc;
  validationResults: ValidationResult[];
}

function getCorrespondingValues(values: number[], registry: Register[]) {
  return values.filter(val => registry.some(reg => reg.DhsId === val)).map(v => v.toString());
}

export class InternalRegistries extends React.Component<InternalRegistriesProps, FormField<number[]>> {
  public death: string[] = [];
  public social: string[] = [];
  public health: string[] = [];

  constructor(props: any) {
    super(props);

    const { value, fieldName, registers } = this.props;
    this.health = getCorrespondingValues(value, registers.internalRegistrieshealthData);
    this.death = getCorrespondingValues(value, registers.internalRegistriescauseOfDeath);
    this.social = getCorrespondingValues(value, registers.internalRegistriessocialServices);
    this.state = {
      value,
      fieldName
    };
  }

  public onChangeDeath = (field: FormFieldMultiString) => {
    this.death = field.value;
    this.onChangeField();
  };
  public onChangeSocial = (field: FormFieldMultiString) => {
    this.social = field.value;
    this.onChangeField();
  };
  public onChangeHealth = (field: FormFieldMultiString) => {
    this.health = field.value;
    this.onChangeField();
  };

  public onChangeField = () => {
    const value = [].concat(this.death, this.social, this.health).map(str => {
      return parseInt(str, 10);
    });
    this.setState(
      {
        value
      },
      () => {
        this.props.onChange(this.state);
      }
    );
  };

  public render() {
    const { Translate, validationResults, registers } = this.props;
    const { value } = this.state;
    return (
      <div>
        <div role="group" aria-labelledby="halsodataregisterLabel">
          <h3 id="halsodataregisterLabel">{Translate('/statisticsOrderFormPage/Halsodataregister')}</h3>
          <CheckBoxGroup
            fieldName="StatisticsOrder.Registers"
            fieldNameOverride="internalRegistrieshealthData"
            value={getCorrespondingValues(value, registers.internalRegistrieshealthData)}
            onChange={this.onChangeHealth}
            errorMessage={getErrorMessageByFieldName(validationResults, 'StatisticsOrder.Registers')}
          >
            {registers.internalRegistrieshealthData.map(reg => (
              <CheckBox id={`${reg.DhsId}_checkbox`} key={reg.DhsId} stringValue={reg.DhsId} label={reg.Name} />
            ))}
          </CheckBoxGroup>
        </div>
        <br />
        <div role="group" aria-labelledby="dodsorsaksregistretLabel">
          <h3 id="dodsorsaksregistretLabel">{Translate('/statisticsOrderFormPage/Dodsorsaksregistret')}</h3>
          <CheckBoxGroup
            fieldName="StatisticsOrder.Registers"
            fieldNameOverride="internalRegistriescauseOfDeath"
            value={getCorrespondingValues(value, registers.internalRegistriescauseOfDeath)}
            onChange={this.onChangeDeath}
            errorMessage={getErrorMessageByFieldName(validationResults, 'StatisticsOrder.Registers')}
          >
            {registers.internalRegistriescauseOfDeath.map(reg => (
              <CheckBox id={`${reg.DhsId}_checkbox`} key={reg.DhsId} stringValue={reg.DhsId} label={reg.Name} />
            ))}
          </CheckBoxGroup>
        </div>
        <br />
        <div role="group" aria-labelledby="socialtjanstregisterLabel">
          <h3 id="socialtjanstregisterLabel">{Translate('/statisticsOrderFormPage/Socialtjanstregister')}</h3>
          <CheckBoxGroup
            fieldName="StatisticsOrder.Registers"
            fieldNameOverride="internalRegistriessocialServices"
            value={getCorrespondingValues(value, registers.internalRegistriessocialServices)}
            onChange={this.onChangeSocial}
            errorMessage={getErrorMessageByFieldName(validationResults, 'StatisticsOrder.Registers')}
          >
            {registers.internalRegistriessocialServices.map(reg => (
              <CheckBox id={`${reg.DhsId}_checkbox`} key={reg.DhsId} stringValue={reg.DhsId} label={reg.Name} />
            ))}
          </CheckBoxGroup>
        </div>
      </div>
    );
  }
}
